import React, { useState, useEffect } from "react";

const StatsCounter = ({ statsBackup, bgColor = "bg-primary", textColor = "text-white" }) => {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch("https://api.npoint.io/edd2c7362f8b9fa85f07");
        if (response.ok) {
          const data = await response.json();
          
          if (Array.isArray(data.stats)) {
            setStats(data.stats);
          } else {
            setStats(statsBackup);
            console.error("API did not return an array:", data);
          }
        }
      } catch (error) {
        setStats(statsBackup);
        console.error("Error fetching stats:", error);
      }
    };

    fetchStats();
  }, {});

  return (
    <div className={`container-fluid ${bgColor} py-5`}>
      <div className="container">
        <div className="row m-1">
          {/* 3. Logical Guard: Ensure stats exists and is an array before mapping */}
          {Array.isArray(stats) && stats.map((item, index) => (
            <div
              key={index}
              className="col-lg-3 col-md-6 wow fadeIn"
              data-wow-delay={`${0.1 * (index + 1)}s`}
            >
              <div className="d-flex counter mb-4 mb-lg-0">
                <h1 className={`me-3 text-secondary counter-value`}>{item.value}</h1>
                <h5 className={`${textColor} mt-1`}>{item.label}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsCounter;